import { Check, Languages } from 'lucide-react';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { LOCALES } from '@/i18n/locales';
import { useI18n } from '@/i18n/useI18n';

export function LanguageSwitcher() {
    const { locale, setLocale } = useI18n();
    const current = LOCALES.find((l) => l.value === locale);

    return (
        <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center gap-1.5 rounded-md px-2 py-1 text-sm text-muted-foreground hover:text-foreground hover:bg-accent/50 outline-none transition-colors">
                <Languages className="h-4 w-4" />
                <span className="text-xs font-semibold">{current?.short}</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {LOCALES.map((loc) => (
                    <DropdownMenuItem
                        key={loc.value}
                        onClick={() => setLocale(loc.value)}
                        className="flex items-center justify-between gap-4"
                    >
                        <span>{loc.label}</span>
                        {loc.value === locale && <Check className="h-4 w-4" />}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
